import React, {useEffect, useState} from 'react';
import {Calendar, Clock, Edit, Plus, Save, Settings as SettingsIcon, Store, Trash2, User, X} from 'lucide-react';
import {StaffSettingTypes, useStaff} from "../staff/useStaff";
import {StaffDetails} from "../staff/staffDetails/staffDetails";
import {StaffServices} from "../staff/staffServices/staffServices";
import {StaffHours} from "../staff/staffHours/staffHours";
import {merge, partition} from "lodash";
import {InviteModal} from "../staff/inviteModal/inviteModal";
import {UpgradeBanner, UpgradeBannerType} from "../billing/components/upgradeBanner";
import {AsButton} from "../subframe";
import {PlusIcon} from "@heroicons/react/24/solid";
import {useStaffDetails} from "../staff/staffDetails/useStaffDetails";
import {useLocations} from "../settings/locations/useLocations";
import {useBusinessServices} from "../businessServices/useBusinessServices";
import {
    AvailabilityableTypes,
    AvailabilityStatusTypes,
    AvailabilityTypes, createAvailabilityOverride, updateAvailabilityOverride,
    updateWeeklyAvailability
} from "../redux/availabilitiesSlice";
import {format, parse} from "date-fns";
import {toast} from "react-toastify";
import {useDispatch} from "react-redux";
import BlockTime from "../staff/blockTimes/BlockTime";

interface Service {
    id: string;
    name: string;
    duration: number;
    price: number;
    enabled: boolean;
}


interface Availability {
    availabilityableId:number;
    availabilityableType:string;
    date:string;
    day:string;
    id:number;
    status:string;
    timeEnd:string;
    timeStart:string;



}



export interface StaffMember {
    account:any
    archivedAt:string
    availabilities:Availability[];
    id: number;
    name: string;
    email: string;
    phone: string | null;
    gender: "male" | "female" | "non_binary" | string; // keep flexible if needed
    avatar: string | null;
    createdAt: string; // or Date if you convert it
    invitePending: boolean;
    key: string | null;
    lastPaymentTransaction: string | null;
    managers: any[];  // replace `any` with a proper Manager type if known
    notes: any[];     // same here—define a Note type if structure is known
    reseller: boolean;
    role: "employee" | "admin" | string; // extend as needed

    services: Service[];
    shops: any;
    // blockedTimes: BlockedTime[];
}


const StaffSettings: React.FC = () => {

    const dispatch = useDispatch();


    const {
        isLoading,
        businessServices,
        onServicePress,
        selectedServiceParams,
        selectedService,
        onServiceNameSave,
        duration,
        setDuration,
        price,
        setPrice,
        onUpdateService,
        isDirty,
        isUpdating,
        onServiceCategoryNameSave,
        showAddCategoryModal,
        setShowAddCategoryModal,
        showAddServiceModal,
        setShowAddServiceModal,
        onAddServiceClick,
        serviceCategoryIdForNewService,
        openCategoryIds,
        setOpenCategoryIds,
        toggleCategory,
        onArchiveServiceCategory,
        onArchiveService,
    } = useBusinessServices();




    const allServicesWithCategory = React.useMemo(() => {
        if (!businessServices) return [];

        return businessServices.flatMap(category =>
            category.services.map((service:any) => ({
                ...service, // Copy all original service properties
                categoryName: category.name, // Add the category name to each service object
            }))
        );
    }, [businessServices]); // Dependency array


    const {
        account,
        onMenuPress,
        path,
        employees,
        onEmployeePress,

        selectedEmployee,
        setSelectedEmployee,
        isInviteModalOpen,
        setIsInviteModalOpen,
        onResendInvite,
        resendCooldown,
        onResetPassword,
        isSendingPasswordReset,
    } = useStaff();


    const {
        validShops, locationStates,
    } = useLocations();


    const {
        onEmployeeUpdate,
        handleShopSelectionChange,
        existingShops,
        employeeShops,
        handleAvatarChange,
        onDisableEmployee,
        onReenableEmployee,
    } = useStaffDetails({
        selectedEmployee,
    });


    useEffect(() => {
        setSelectedStaffAvailabilities(selectedEmployee?.availabilities)
    }, [selectedEmployee]);

    // const view = () => {
    //     switch (path) {
    //         case StaffSettingTypes.STAFF_DETAILS:
    //             return <StaffDetails selectedEmployee={selectedEmployee}/>;
    //         case StaffSettingTypes.SERVICES:
    //             return <StaffServices selectedEmployee={selectedEmployee}/>;
    //         case StaffSettingTypes.HOURS:
    //             return <StaffHours selectedEmployee={selectedEmployee}/>;
    //         default:
    //             return <StaffDetails selectedEmployee={selectedEmployee}/>;
    //     }
    // };




    // const [invitedEmployees, activeEmployees] = partition(employees, (employee) => employee.invitePending);


    const [showAddModal, setShowAddModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [selectedStaff, setSelectedStaff] = useState<StaffMember | null>(selectedEmployee);
    const [selectedStaffAvailabilities, setSelectedStaffAvailabilities] = useState<Availability[] | null>([]);

    const [activeTab, setActiveTab] = useState<'info' | 'locations' | 'hours' | 'services' | 'blocked'>('info');



    const [newStaff, setNewStaff] = useState<Partial<StaffMember>>({});





    const availableServices = [{id: '1', name: 'Botox Treatment', defaultDuration: 45, defaultPrice: 450}, {
        id: '2', name: 'Dermal Fillers', defaultDuration: 60, defaultPrice: 650
    }, {id: '3', name: 'Chemical Peel', defaultDuration: 90, defaultPrice: 280}, {
        id: '4', name: 'Laser Hair Removal', defaultDuration: 45, defaultPrice: 350
    }, {id: '5', name: 'CoolSculpting', defaultDuration: 120, defaultPrice: 750}, {
        id: '6', name: 'Microneedling', defaultDuration: 60, defaultPrice: 320
    }, {id: '7', name: 'Facial Treatment', defaultDuration: 75, defaultPrice: 200}];

    const handleAddStaff = () => {
        // if (newStaff.name && newStaff.email && newStaff.role) {
        //     const staff: StaffMember = {
        //         id: Date.now().toString(),
        //         name: newStaff.name,
        //         email: newStaff.email,
        //         phone: newStaff.phone || '',
        //         role: newStaff.role,
        //         status: newStaff.status || 'active',
        //         locations: newStaff.locations || [],
        //         workingHours: newStaff.workingHours || {},
        //         services: newStaff.services || [],
        //         blockedTimes: newStaff.blockedTimes || []
        //     };
        //     setStaffMembers(prev => [...prev, staff]);
        //     setNewStaff({
        //         name: '', email: '', phone: '', role: '', status: 'active', locations: [], workingHours: {
        //             monday: {enabled: true, startTime: '09:00', endTime: '18:00'},
        //             tuesday: {enabled: true, startTime: '09:00', endTime: '18:00'},
        //             wednesday: {enabled: true, startTime: '09:00', endTime: '18:00'},
        //             thursday: {enabled: true, startTime: '09:00', endTime: '18:00'},
        //             friday: {enabled: true, startTime: '09:00', endTime: '18:00'},
        //             saturday: {enabled: false, startTime: '09:00', endTime: '17:00'},
        //             sunday: {enabled: false, startTime: '10:00', endTime: '16:00'}
        //         }, services: [], blockedTimes: []
        //     });
        //     setShowAddModal(false);
        // }
    };

    const handleEditStaff = (staff: StaffMember) => {
        setSelectedStaff(staff);
        setShowEditModal(true);
    };

    const handleUpdateStaff = () => {
        if (selectedStaff) {
            // setStaffMembers(prev => prev.map(staff => staff.id === selectedStaff.id ? selectedStaff : staff));
            setShowEditModal(false);
            setSelectedStaff(null);
        }
    };

    const handleDeleteStaff = (staffId: string) => {
        if (window.confirm('Are you sure you want to delete this staff member?')) {
            // setStaffMembers(prev => prev.filter(staff => staff.id !== staffId));
        }
    };

    const addServiceToStaff = (serviceId: string) => {
        const service = availableServices.find(s => s.id === serviceId);
        if (service && selectedStaff) {
            const newService: Service = {
                id: serviceId,
                name: service.name,
                duration: service.defaultDuration,
                price: service.defaultPrice,
                enabled: true
            };
            setSelectedStaff(prev => prev ? {
                ...prev, services: [...prev.services, newService]
            } : null);
        }
    };

    const removeServiceFromStaff = (serviceId: string) => {
        if (selectedStaff) {
            setSelectedStaff(prev => prev ? {
                ...prev, services: prev.services.filter(s => s.id !== serviceId)
            } : null);
        }
    };

    const updateService = (serviceId: string, updates: Partial<Service>) => {
        if (selectedStaff) {
            setSelectedStaff(prev => prev ? {
                ...prev, services: prev.services.map(s => s.id === serviceId ? {...s, ...updates} : s)
            } : null);
        }
    };



    //
    const handleAvailabilitySubmit = async (availabilityChanges: any) => {
        // const updatedAvailability = {
        //     ...availability,
        //     ...availabilityChanges,
        //     // type: availabilityEditingIntent,
        //     // date: availability?.date,
        //     // day: availability?.day.toLowerCase(),
        // };
        // if (availabilityChanges?.timeStart) {
        //     updatedAvailability.formattedTimeStart = format(
        //         parse(availabilityChanges.timeStart, "HH:mm", availability.date),
        //         "hh:mm a"
        //     );
        // }
        //
        // if (availabilityChanges?.timeEnd) {
        //     updatedAvailability.formattedTimeEnd = format(
        //         parse(availabilityChanges.timeEnd, "HH:mm", availability.date),
        //         "hh:mm a"
        //     );
        // }

        try {

            // await dispatch(
            //     updateWeeklyAvailability({
            //         employeeId: 4,
            //         availability:{}
                    // availability: merge(updatedAvailability, {
                        // date: availability?.date,
                        // day: availability?.day.toLowerCase(),
                    // }
                    // ),
                // }) as any
            // ).unwrap();


            // if (
            //     availabilityEditingIntent === AvailabilityTypes.WEEKLY_AVAILABILITY &&
            //     updatedAvailability.type === AvailabilityTypes.WEEKLY_AVAILABILITY
            // ) {
            //     await dispatch(
            //         updateWeeklyAvailability({
            //             employeeId: availability?.availabilityableId,
            //             availability: merge(updatedAvailability, {
            //                 date: availability?.date,
            //                 day: availability?.day.toLowerCase(),
            //             }),
            //         }) as any
            //     ).unwrap();
            // } else if (
            //     availabilityEditingIntent === AvailabilityTypes.AVAILABILITY_OVERRIDE &&
            //     updatedAvailability.type === AvailabilityTypes.AVAILABILITY_OVERRIDE
            // ) {
            //     await dispatch(
            //         updateAvailabilityOverride({
            //             employeeId: availability?.availabilityableId,
            //             availability: merge(updatedAvailability, {
            //                 date: availability?.date,
            //                 day: availability?.day.toLowerCase(),
            //             }),
            //         }) as any
            //     ).unwrap();
            // } else if (
            //     availabilityEditingIntent === AvailabilityTypes.WEEKLY_AVAILABILITY &&
            //     availability?.type === AvailabilityTypes.AVAILABILITY_OVERRIDE
            // ) {
            //     await dispatch(
            //         updateAvailabilityOverride({
            //             employeeId: availability?.availabilityableId,
            //             availability: merge(updatedAvailability, {
            //                 date: availability?.date,
            //                 day: availability?.day.toLowerCase(),
            //             }),
            //             shouldUpdateWeekly: true,
            //         }) as any
            //     ).unwrap();
            // } else if (
            //     availabilityEditingIntent === AvailabilityTypes.AVAILABILITY_OVERRIDE &&
            //     availability?.type === AvailabilityTypes.WEEKLY_AVAILABILITY
            // ) {
            //     await dispatch(
            //         createAvailabilityOverride({
            //             employeeId: availability?.availabilityableId,
            //             availability: merge(updatedAvailability, {
            //                 date: availability?.date,
            //                 day: availability?.day.toLowerCase(),
            //             }),
            //         }) as any
            //     ).unwrap();
            // }
            toast.success("Availability updated successfully");
        } catch (err) {
            console.error("Error handling availability submission:", err);
            // setError(
            //     "An error occurred while submitting availability?. Please try again."
            // );
        }
    };

    // const onScheduledSwitchToggle = async (checked: boolean) => {
    //     setScheduled(checked);
    //     try {
    //         await handleAvailabilitySubmit({
    //             ...availability,
    //             availabilityableType: AvailabilityableTypes.USER,
    //             status: checked
    //                 ? AvailabilityStatusTypes.SCHEDULED
    //                 : AvailabilityStatusTypes.UNSCHEDULED,
    //         });
    //     } catch (err) {
    //         console.error("Error handling availability submission:", err);
    //         setError(
    //             "An error occurred while updating the schedule. Please try again."
    //         );
    //     }
    // };
    const handleToggleAvailability = (id: number, enabled: boolean) => {
        setSelectedStaffAvailabilities((prev:any) =>
            prev?.map((a:any) =>
                a.id === id
                    ? { ...a, status: enabled ? "scheduled" : "disabled" }
                    : a
            )
        );







    };




    return (


        <>
            <InviteModal
                isOpen={isInviteModalOpen}
                onOpenChange={setIsInviteModalOpen}
            />
            <div className=" flex flex-col w-full">
                <div className="flex items-center justify-between">
                    <h2 className="text-xl py-3 font-semibold text-gray-900">Staff Management</h2>
                    <div className="flex gap-6">
                        <AsButton
                            className="border-none gap-2 w-full mb-3 bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 flex items-center space-x-2"
                            onClick={() => setIsInviteModalOpen(true)}
                            // disabled={!account?.paywallPermissions?.addStaff || !account?.paywallPermissions?.addStaff}
                        >
                            <PlusIcon className="w-4 h-4 text-white"/>
                            <p className="text-white font-body-bold">
                                Add staff member
                            </p>
                        </AsButton>
                    </div>

                </div>


                {/*{!account?.paywallPermissions?.addStaff && (<div className={'py-2'}>*/}
                {/*    <UpgradeBanner*/}
                {/*        text={`You've reached the ${account?.paywallPermissions?.staffLimit} staff limit. Upgrade to add more.`}*/}
                {/*        type={UpgradeBannerType.BANNER}*/}
                {/*    />*/}
                {/*</div>)}*/}


                <div className="bg-white rounded-lg border border-gray-200">
                    <div className="overflow-x-auto">
                        <table className="w-full">
                            <thead className="bg-gray-50">
                            <tr>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                    Staff Member
                                </th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Role</th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Contact</th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Locations</th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Services</th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
                            </tr>
                            </thead>
                            <tbody className="bg-white divide-y divide-gray-200">
                            {employees.map((employee: any) => (<tr
                                key={employee.id}

                                className={`cursor-pointer hover:bg-gray-50 ${employee.id === selectedEmployee?.id ? 'bg-blue-50' : ''}`}
                            >
                                <td className="px-6 py-4 whitespace-nowrap">
                                    <div className="flex items-center">
                                        <div
                                            className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center mr-3 flex-shrink-0">
                                            {employee?.avatar ? (<img src={employee?.avatar} alt={employee.name}
                                                                     className="w-10 h-10 rounded-full object-cover"/>) : (// Fallback to initials if no photo is available
                                                <User className="w-5 h-5 text-blue-600"/>)}
                                        </div>
                                        <div>
                                            <div className="text-sm font-medium text-gray-900">{employee.name}</div>
                                            <div className="text-sm text-gray-500">ID: {employee.id}</div>
                                        </div>
                                    </div>
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap">
                                    <span className="text-sm text-gray-900">{employee.role || 'N/A'}</span>
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap">
                                    <div className="text-sm text-gray-900">{employee.email || 'No email'}</div>
                                    <div className="text-sm text-gray-500">{employee.phone || 'No phone'}</div>
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap">
                        <span
                            className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${!employee.invitePending ? 'bg-green-50 text-green-400' : 'bg-red-50 text-red-400'}`}>
                          {employee.invitePending ? 'Pending' : 'Active'}
                        </span>
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap">
                                    <div className="flex flex-wrap gap-1">
                                        {employee.shops?.length > 0 ? (employee.shops.map((location: any) => {
                                            return (<span key={location.id}
                                                          className="inline-flex px-2 py-1 text-xs font-medium rounded-full bg-blue-100 text-blue-800">
                                            {location.name}
                                        </span>)
                                        })) : (<span className="text-sm text-gray-500">No locations</span>)}
                                    </div>
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap">
                                        <span
                                            className="text-sm text-gray-900">{employee?.services?.filter(((s:any)=>s.status?.toLowerCase()==='active')).length || 0} services</span>
                                </td>

                                <td className="px-6 py-4 whitespace-nowrap">
                                    <div className="flex space-x-2">
                                        <button
                                            onClick={() => onEmployeePress({employeeId: employee.id})}
                                            className="p-1 text-gray-400 hover:text-gray-600"
                                        >
                                            <Edit className="w-4 h-4"/>
                                        </button>
                                        <button
                                            onClick={() => {
                                                onDisableEmployee(employee)
                                            }}
                                            className="p-1 text-red-400 hover:text-red-600"
                                        >
                                            <Trash2 className="w-4 h-4"/>
                                        </button>
                                    </div>
                                </td>

                            </tr>))}
                            </tbody>
                        </table>
                    </div>
                </div>


                {/* Add Staff Modal */}
                {showAddModal && (
                    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                        <div className="bg-white rounded-lg shadow-xl w-full max-w-md mx-4">
                            <div className="flex items-center justify-between p-6 border-b border-gray-200">
                                <h2 className="text-xl font-semibold text-gray-900">Add New Staff Member</h2>
                                <button
                                    onClick={() => setShowAddModal(false)}
                                    className="p-2 hover:bg-gray-100 rounded-lg"
                                >
                                    <X className="w-5 h-5"/>
                                </button>
                            </div>

                            <div className="p-6 space-y-4">
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">Name *</label>
                                    <input
                                        type="text"
                                        required
                                        value={newStaff.name || ''}
                                        onChange={(e) => setNewStaff(prev => ({...prev, name: e.target.value}))}
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                        placeholder="Enter staff name"
                                    />
                                </div>

                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">Email *</label>
                                    <input
                                        type="email"
                                        required
                                        value={newStaff.email || ''}
                                        onChange={(e) => setNewStaff(prev => ({...prev, email: e.target.value}))}
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                        placeholder="Enter email address"
                                    />
                                </div>

                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">Phone</label>
                                    <input
                                        type="tel"
                                        value={newStaff.phone || ''}
                                        onChange={(e) => setNewStaff(prev => ({...prev, phone: e.target.value}))}
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                        placeholder="Enter phone number"
                                    />
                                </div>

                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">Role *</label>
                                    <input
                                        type="text"
                                        required
                                        value={newStaff.role || ''}
                                        onChange={(e) => setNewStaff(prev => ({...prev, role: e.target.value}))}
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                        placeholder="e.g., Lead Practitioner, Senior Practitioner"
                                    />
                                </div>

                                {/*<div>*/}
                                {/*    <label className="block text-sm font-medium text-gray-700 mb-2">Status</label>*/}
                                {/*    <select*/}
                                {/*        value={newStaff.status || 'active'}*/}
                                {/*        onChange={(e) => setNewStaff(prev => ({*/}
                                {/*            ...prev, status: e.target.value as 'active' | 'inactive'*/}
                                {/*        }))}*/}
                                {/*        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"*/}
                                {/*    >*/}
                                {/*        <option value="active">Active</option>*/}
                                {/*        <option value="inactive">Inactive</option>*/}
                                {/*    </select>*/}
                                {/*</div>*/}

                                <div className="flex justify-end space-x-3 pt-4 border-t border-gray-200">
                                    <button
                                        onClick={() => setSelectedEmployee(null)}
                                        className="px-4 py-2 text-gray-700 border border-gray-300 rounded-lg hover:bg-gray-50"
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        onClick={handleAddStaff}
                                        disabled={!newStaff.name || !newStaff.email || !newStaff.role}
                                        className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:bg-gray-300 disabled:cursor-not-allowed flex items-center space-x-2"
                                    >
                                        <Save className="w-4 h-4"/>
                                        <span>Add Staff</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>)}

                {/* Edit Staff Modal */}
                {/*{selectedEmployee && view()}*/}

                {selectedEmployee && (
                    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                        <div
                            className="bg-white rounded-lg shadow-xl w-full max-w-4xl mx-4 max-h-[90vh] overflow-y-auto">
                            <div className="flex items-center justify-between p-6 border-b border-gray-200">
                                <div>
                                <h2 className="text-xl font-semibold text-gray-900">Edit Staff Member</h2>
                                    {
                                        !selectedEmployee?.invitePending && <div className={'flex gap-2 align-middle justify-start items-center'}>
                                            <span className={'text-sm text-gray-500'}>Employee Code: {selectedEmployee?.invitationToken}</span>
                                            <button onClick={()=>onResetPassword(selectedEmployee)} disabled={isSendingPasswordReset} className={'bg-yellow-400 px-2 py-1 rounded disabled:opacity-50'}>
                                                {isSendingPasswordReset ? 'Sending...' : 'Reset Password'}
                                            </button>
                                        </div>
                                    }



                                    {selectedEmployee?.invitePending && <div className={'flex gap-2 align-middle justify-start items-center'}>

                                        <span className={'text-sm text-gray-500'}>This User's Invitation is still pending</span>
                                        <button onClick={()=>onResendInvite(selectedEmployee)} className={'bg-yellow-400 px-2 py-1 rounded'}>Re-invite</button>
                                    </div>
                                    }
                                </div>

                                <button
                                    onClick={() => {
                                        setSelectedEmployee(null)
                                    }}
                                    className="p-2 hover:bg-gray-100 rounded-lg"
                                >
                                    <X className="w-5 h-5"/>
                                </button>
                            </div>

                            {/* Tab Navigation */}
                            <div className="border-b border-gray-200">
                                <nav className="flex space-x-8 px-6">
                                    {[{id: 'info', label: 'Basic Info', icon: User}, {
                                        id: 'locations', label: 'Locations', icon: Store
                                    }, {id: 'hours', label: 'Working Hours', icon: Clock}, {
                                        id: 'services', label: 'Services', icon: SettingsIcon
                                    },
                                        {id: 'blocked', label: 'Blocked Times', icon: Calendar}
                                    ].map((tab) => {
                                        const Icon = tab.icon;
                                        return (<button
                                            key={tab.id}
                                            onClick={() => setActiveTab(tab.id as any)}
                                            className={`py-4 px-1 border-b-2 font-medium text-sm flex items-center space-x-2 ${activeTab === tab.id ? 'border-blue-500 text-blue-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`}
                                        >
                                            <Icon className="w-4 h-4"/>
                                            <span>{tab.label}</span>
                                        </button>);
                                    })}
                                </nav>
                            </div>

                            <div className="p-6">
                                {/* Basic Info Tab */}


                                {activeTab === 'info' && (<StaffDetails selectedEmployee={selectedEmployee} onResendInvite={onResendInvite}/>)}


                                {
                                    activeTab === 'locations' && (

                                    <div className="space-y-6 pb-6">
                                        <div>
                                            <h3 className="text-lg font-medium text-gray-900 mb-4">Work
                                                Locations</h3>
                                            <p className="text-sm text-gray-600 mb-6">Select which locations this
                                                staff
                                                member works at.</p>

                                            <div className="space-y-3">
                                                {validShops?.length===0 &&  "No Shop Found"}

                                                {validShops?.length > 0 && validShops.map((shop) => {
                                                    const locationState = locationStates[shop.id];


                                                    return (<>

                                                            <div key={shop.id}
                                                                 className="flex items-center justify-between p-4 border border-gray-200 rounded-lg">
                                                                <div className="flex items-center space-x-3">
                                                                    <div
                                                                        className="w-8 h-8 bg-blue-100 rounded-lg flex items-center justify-center">
                                                                        <Store className="w-4 h-4 text-blue-600"/>
                                                                    </div>
                                                                    <div>
                                                                        <h4 className="font-medium text-gray-900">{shop.name}</h4>
                                                                        <p className="text-sm text-gray-500">{shop?.addressLine1}</p>
                                                                    </div>
                                                                </div>
                                                                <label className="flex items-center">
                                                                    <input
                                                                        type="checkbox"
                                                                        checked={selectedEmployee?.shops?.some((loc:any) => loc.id === shop.id) || false}
                                                                        // onChange={(e) => {
                                                                        //     if (selectedEmployee) {
                                                                        //         const currentLocations = selectedEmployee.shops || [];
                                                                        //         let newLocations:any[];
                                                                        //
                                                                        //         if (e.target.checked) {
                                                                        //             // [FIXED] Add the entire 'shop' object to the array.
                                                                        //             newLocations = [...currentLocations, shop];
                                                                        //         } else {
                                                                        //             // [FIXED] Remove the object from the array by filtering based on its ID.
                                                                        //             newLocations = currentLocations.filter((loc:any) => loc.id !== shop.id);
                                                                        //         }
                                                                        //
                                                                        //         setSelectedEmployee((prev:any) =>
                                                                        //             prev ? { ...prev, shops: newLocations } : null
                                                                        //         );
                                                                        //     }
                                                                        // }}
                                                                        onChange={(e) => handleShopSelectionChange(shop, e.target.checked)}

                                                                        className="mr-2 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                                                                    />
                                                                    <span
                                                                        className="text-sm text-gray-600">Available at this location</span>
                                                                </label>
                                                            </div>

                                                            {validShops.length === 0 && (
                                                                <div className="text-center py-8 text-gray-500">
                                                                    <Store
                                                                        className="w-12 h-12 mx-auto mb-4 text-gray-300"/>
                                                                    <p>No locations configured</p>
                                                                    <p className="text-sm">Add locations in Business
                                                                        Settings first</p>
                                                                </div>)}
                                                        </>


                                                    )
                                                })}


                                            </div>


                                        </div>

                                    </div>)
                                }


                                {/* Working Hours Tab */}
                                {activeTab === 'hours' && <StaffHours selectedEmployee={selectedEmployee}/>}







                                {activeTab === 'services' && <StaffServices selectedEmployee={selectedEmployee}/>}


                                {/* Blocked Times Tab */}
                                {activeTab === 'blocked' && <BlockTime selectedEmployee={selectedEmployee}/>}

                                {/* Save Button */}
                                <div className="flex justify-end space-x-3 pt-6 border-t border-gray-200">
                                    <button

                                        onClick={() => {
                                            setSelectedEmployee(null);
                                            setShowEditModal(false);
                                            setSelectedStaff(null);
                                        }}

                                        className="px-4 py-2 text-gray-700 border border-gray-300 rounded-lg hover:bg-gray-50"
                                    >
                                        Cancel
                                    </button>
                                    {/*<button*/}
                                    {/*    onClick={handleUpdateStaff}*/}
                                    {/*    className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 flex items-center space-x-2"*/}
                                    {/*>*/}
                                    {/*    <Save className="w-4 h-4"/>*/}
                                    {/*    <span>Save Changes</span>*/}
                                    {/*</button>*/}
                                </div>
                            </div>
                        </div>
                    </div>)}
            </div>
        </>

    );
};

export default StaffSettings;
